export var getOffset = function getOffset(offsetProp, dimension) {
  return offsetProp && dimension ? offsetProp - dimension + "px" : undefined;
};